import script from "./multi-file-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-file-upload.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__